export const LOCAL = 'local';
export const DEVMAJ = 'devmaj';
export const MAJSTG = 'majstg';
export const PRD = 'prd';
